export default {
  devices: [
    {
      name: "Desktop",
      width: "", // default size
    },
    {
      name: "Tablet",
      width: "900px",
    },
    {
      name: "Mobile",
      width: "320px", // this value will be used on canvas width
      // widthMedia: "480px", // this value will be used in CSS @media
    },
  ],
}
